import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { ActiveRateCodeModel } from '../../models/reports/active-ratecode.model';
import { ActiveRateCodeService } from '../../service/active-ratecode.service';
import { ExportExcelService } from '../../service/export-excel.service';
import { NotificationType } from '../../enum/notification-type.enum';
import { NotificationService } from 'src/app/service/notification.service';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-active-rate-code-report',
  templateUrl: './active-rate-code-report.component.html',
  styleUrls: ['./active-rate-code-report.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ActiveRateCodeReportComponent implements OnInit {
  mySalesChannelSet = new Set<string>();
  constructor(private router: Router, private activeRateCodeService: ActiveRateCodeService,
    private notificationService: NotificationService, private exportExcelService: ExportExcelService) { }
  activeRateCodeModel = new ActiveRateCodeModel(0, 0, '', '', '', '', [], [], '', '', null, null);
  public activeRateCodeData: ActiveRateCodeModel[] = [];

  public showLoading: boolean;
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public loggedinUser: string = '';

  public dataSource = new MatTableDataSource<ActiveRateCodeModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  public displayedColumns = ['corp', 'rcode', 'rdesc', 'valid_from_dt', 'valid_to_dt'];

  ngOnInit(): void {
    
    this.activeRateCodeModel = this.activeRateCodeService.activeRateCodeModel
    this.mySalesChannelSet = this.activeRateCodeService.mySalesChannelSet;

    this.activeRateCodeModel.corps = this.activeRateCodeService.activeRateCodeModel.corps;
    this.activeRateCodeModel.salesChannelFieldValue = this.activeRateCodeService.activeRateCodeModel.salesChannelFieldValue;
    this.activeRateCodeModel.productId = this.activeRateCodeService.activeRateCodeModel.productId;
    this.activeRateCodeModel.valid_from_dt = this.activeRateCodeService.activeRateCodeModel.valid_from_dt;

    this.getRateCodeDetails();
  }

  public ExportTOExcel() {
    this.exportExcelService.exportFromHtmlTable(this.table.nativeElement, 'ActiveRateCodeData');
  }

  public getRateCodeDetails(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.activeRateCodeService.getRateCodeDetails(this.activeRateCodeModel.corps, this.activeRateCodeModel.salesChannelFieldValue, this.activeRateCodeModel.productId, this.activeRateCodeModel.valid_from_dt).subscribe(
        (response: ActiveRateCodeModel[]) => {
          this.dataSource.data = response as ActiveRateCodeModel[];
          //this.activeRateCodeData = response;
          this.refreshing = false;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
          this.refreshing = false;
        }
      )
    );
  }

  

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }


  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
